<template>
    <div class="checkout">
        <checkout-payment-creditcard v-if="paymentMethod === 'creditcard'"
                                     :module-link="moduleLink"
                                     :checkout-link="checkoutLink"
                                     :checkout-cancel-payment-link="checkoutCancelPaymentLink"
        >
        </checkout-payment-creditcard>

        <checkout-payment-bancontact v-else-if="paymentMethod === 'bancontact'"
                                     :shop-name="shopName"
                                     :module-link="moduleLink"
                                     :checkout-link="checkoutLink"
                                     :checkout-cancel-payment-link="checkoutCancelPaymentLink"
        >
        </checkout-payment-bancontact>

        <div v-else>
            <p class="text-center">{{ $t("checkout.errorText") }} :(</p>
        </div>
    </div>
</template>

<script>
    import CheckoutProgress from './CheckoutProgress';
    import CheckoutPaymentCreditcard from './CheckoutPaymentCreditcard';
    import CheckoutPaymentBancontact from './CheckoutPaymentBancontact';
    import CheckoutPaymentCreditCardLogo from './CheckoutPaymentCreditcardLogo';
    import ModalVue from "./ModalVue";

    export default {
        props: {
            paymentMethod: {
                type: String,
                required: true
            },
            moduleLink: {
                type: String,
                required: true
            },
            checkoutLink: {
                type: String,
                required: true
            },
            checkoutCancelPaymentLink: {
                type: String,
                required: true
            },
            shopName: {
                type: String,
                default: ''
            }
        },
        components: {
            CheckoutPaymentCreditcard,
            CheckoutPaymentBancontact,
            CheckoutPaymentCreditCardLogo,
            CheckoutProgress,
            ModalVue
        },
        data() {
            return {

            };
        },
        methods: {

        },
        mounted() {
            window.addEventListener('resize', () => {
                this.windowWidth = window.innerWidth
            });
        }
    };
</script>
